export const spacingMap = {
    xxs: 0,
    xs: 1,
    s: 2,
    m: 3,
    l: 4,
    xl: 5,
    xxl: 6,
    'xxl-2': 7,
    'xxl-3': 9,
    'xxl-4': 10,
};

const calcMuiSpacing = (spacing) => {
    if (typeof spacing === 'number') {
        return spacing;
    }

    return spacingMap[spacing] || 0;
}

export default calcMuiSpacing;



// WEBPACK FOOTER //
// ./src/components/controls/grid/calcMuiSpacing.js